module.exports = __webpack_public_path__ + "static/media/snapshot.23f38073.svg";